"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var deMessages = require("./messages/de_DE.json");
var enGBMessages = require("./messages/en_GB.json");
var enUSMessages = require("./messages/en_US.json");
var esMessages = require("./messages/es_ES.json");
var frMessages = require("./messages/fr_FR.json");
var itMessages = require("./messages/it_IT.json");
var jaMessages = require("./messages/ja_JP.json");
var koMessages = require("./messages/ko_KR.json");
var ptMessages = require("./messages/pt_BR.json");
var TabLoc = require("../gen-src/Localize");
var zhsMessages = require("./messages/zh_CN.json");
var zhtMessages = require("./messages/zh_TW.json");
// import * as gaMessages from './messages/ga_IE.json';
// In order to support running in Phoenix we create a local structure that contains the localized version of the engine strings.
// If the engine locale has been manually set, then we use this local set of messages.  Otherwise we use @tableau/localize.
// tslint:disable-next-line:no-any
var localMessageMap = (_a = {},
    _a['en_GB'] = postProcessMessages(enGBMessages),
    _a['en_US'] = postProcessMessages(enUSMessages),
    _a['de_DE'] = postProcessMessages(deMessages),
    _a['es_ES'] = postProcessMessages(esMessages),
    _a['fr_FR'] = postProcessMessages(frMessages),
    // ['ga_IE']: postProcessMessages(gaMessages),
    _a['it_IT'] = postProcessMessages(itMessages),
    _a['ja_JP'] = postProcessMessages(jaMessages),
    _a['ko_KR'] = postProcessMessages(koMessages),
    _a['pt_BR'] = postProcessMessages(ptMessages),
    _a['zh_CN'] = postProcessMessages(zhsMessages),
    _a['zh_TW'] = postProcessMessages(zhtMessages),
    _a);
var fallbackLocale = 'en_US';
// tslint:disable-next-line:no-any
var messageMap;
/**
 * Inject the metrics engine with the locale-specific information it needs.
 * @param messageLocale the Tableau-supported locale for message strings.
 * @param getLocalizeFormatOverride an optional platform specific override for `getLocalizeFormat` to allow use in react native.
 */
function setEngineLocale(messageLocale, 
// tslint:disable-next-line: no-any
getLocalizeFormatOverride) {
    messageMap = localMessageMap[messageLocale] || localMessageMap[fallbackLocale];
    if (getLocalizeFormatOverride) {
        // tslint:disable-next-line:no-any whitespace
        TabLoc.getLocalizeFormat = getLocalizeFormatOverride;
    }
}
exports.setEngineLocale = setEngineLocale;
var getMessage = function (messageId) {
    return messageMap[messageId] || localMessageMap[fallbackLocale][messageId] || 'LOCERR_' + messageId;
};
// tslint:disable-next-line:no-any
function postProcessMessages(messages) {
    if (typeof messages.records !== 'undefined') {
        Object.keys(messages.records).forEach(function (key) {
            messages[messages.records[key].id] = messages.records[key].message;
        });
        messages.records = null;
    }
    else {
        Object.keys(messages).forEach(function (key) {
            var message = messages[key];
            if (typeof message !== 'string') {
                messages[key] = message.message;
            }
        });
    }
    return messages;
}
/**
 * Adding a string is a two-step process.
 * 1) The string itself needs to be defined in ./messages/en_US.json.
 * 2) an accessor method needs to be added to the Messages object below.
 */
exports.Messages = {
    // tslint:disable-next-line:readonly-array
    formatString: function (str, args) {
        return str.replace(/{(\w+)}/g, function (match, index) { return args[index] || ''; });
    },
    metricsComparisonNoChange: function () {
        return messageMap ? getMessage('metricsComparisonNoChange') : TabLoc.Messages.metricsComparisonNoChange();
    },
    metricsComparisonAtTarget: function () {
        return messageMap ? getMessage('metricsComparisonAtTarget') : TabLoc.Messages.metricsComparisonAtTarget();
    },
    metricsComparisonBelowTarget: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsComparisonBelowTarget'), a)
            : TabLoc.Messages.metricsComparisonBelowTarget(a);
    },
    metricsComparisonAboveTarget: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsComparisonAboveTarget'), a)
            : TabLoc.Messages.metricsComparisonAboveTarget(a);
    },
    metricsComparisonBelowTargetDetail: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsComparisonBelowTargetDetail'), a)
            : TabLoc.Messages.metricsComparisonBelowTargetDetail(a);
    },
    metricsComparisonAboveTargetDetail: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsComparisonAboveTargetDetail'), a)
            : TabLoc.Messages.metricsComparisonAboveTargetDetail(a);
    },
    metricsSecondComparisonSingular: function () {
        return messageMap
            ? getMessage('metricsSecondComparisonSingular')
            : TabLoc.Messages.metricsSecondComparisonSingular();
    },
    metricsSecondComparisonPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsSecondComparisonPlural'), a)
            : TabLoc.Messages.metricsSecondComparisonPlural(a);
    },
    metricsMinuteComparisonSingular: function () {
        return messageMap
            ? getMessage('metricsMinuteComparisonSingular')
            : TabLoc.Messages.metricsMinuteComparisonSingular();
    },
    metricsMinuteComparisonPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsMinuteComparisonPlural'), a)
            : TabLoc.Messages.metricsMinuteComparisonPlural(a);
    },
    metricsHourComparisonSingular: function () {
        return messageMap ? getMessage('metricsHourComparisonSingular') : TabLoc.Messages.metricsHourComparisonSingular();
    },
    metricsHourComparisonPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsHourComparisonPlural'), a)
            : TabLoc.Messages.metricsHourComparisonPlural(a);
    },
    metricsDayComparisonSingular: function () {
        return messageMap ? getMessage('metricsDayComparisonSingular') : TabLoc.Messages.metricsDayComparisonSingular();
    },
    metricsDayComparisonPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsDayComparisonPlural'), a)
            : TabLoc.Messages.metricsDayComparisonPlural(a);
    },
    metricsWeekComparisonSingular: function () {
        return messageMap ? getMessage('metricsWeekComparisonSingular') : TabLoc.Messages.metricsWeekComparisonSingular();
    },
    metricsWeekComparisonPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsWeekComparisonPlural'), a)
            : TabLoc.Messages.metricsWeekComparisonPlural(a);
    },
    metricsMonthComparisonSingular: function () {
        return messageMap ? getMessage('metricsMonthComparisonSingular') : TabLoc.Messages.metricsMonthComparisonSingular();
    },
    metricsMonthComparisonPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsMonthComparisonPlural'), a)
            : TabLoc.Messages.metricsMonthComparisonPlural(a);
    },
    metricsQuarterComparisonSingular: function () {
        return messageMap
            ? getMessage('metricsQuarterComparisonSingular')
            : TabLoc.Messages.metricsQuarterComparisonSingular();
    },
    metricsQuarterComparisonPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsQuarterComparisonPlural'), a)
            : TabLoc.Messages.metricsQuarterComparisonPlural(a);
    },
    metricsYearComparisonSingular: function () {
        return messageMap ? getMessage('metricsYearComparisonSingular') : TabLoc.Messages.metricsYearComparisonSingular();
    },
    metricsYearComparisonPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsYearComparisonPlural'), a)
            : TabLoc.Messages.metricsYearComparisonPlural(a);
    },
    metricsMarkComparisonSingular: function () {
        return messageMap ? getMessage('metricsMarkComparisonSingular') : TabLoc.Messages.metricsMarkComparisonSingular();
    },
    metricsMarkComparisonPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsMarkComparisonPlural'), a)
            : TabLoc.Messages.metricsMarkComparisonPlural(a);
    },
    metricsNoValue: function () {
        return messageMap ? getMessage('metricsNoValue') : TabLoc.Messages.metricsNoValue();
    },
    metricsComparisonTimestamp: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsComparisonTimestamp'), a)
            : TabLoc.Messages.metricsComparisonTimestamp(a);
    },
    metricsComparisonTimestampTwoLines: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsComparisonTimestampTwoLines'), a)
            : TabLoc.Messages.metricsComparisonTimestampTwoLines(a);
    },
    metricsLegend: function (a) {
        return messageMap ? exports.Messages.formatString(getMessage('metricsLegend'), a) : TabLoc.Messages.metricsLegend(a);
    },
    metricsLegendTwoLines: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsLegendTwoLines'), a)
            : TabLoc.Messages.metricsLegendTwoLines(a);
    },
    metricsWeekOf: function (a) {
        return messageMap ? exports.Messages.formatString(getMessage('metricsWeekOf'), a) : TabLoc.Messages.metricsWeekOf(a);
    },
    metricsWeekOfTwoLines: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsWeekOfTwoLines'), a)
            : TabLoc.Messages.metricsWeekOfTwoLines(a);
    },
    metricsFY: function (a) {
        return messageMap ? exports.Messages.formatString(getMessage('metricsFY'), a) : TabLoc.Messages.metricsFY(a);
    },
    metricsFYQuarter: function (a) {
        return messageMap ? exports.Messages.formatString(getMessage('metricsFYQuarter'), a) : TabLoc.Messages.metricsFYQuarter(a);
    },
    metricsNoComparisonRowSubtitle: function () {
        return messageMap ? getMessage('metricsNoComparisonRowSubtitle') : TabLoc.Messages.metricsNoComparisonRowSubtitle();
    },
    metricsTargetRowSubtitle: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsTargetRowSubtitle'), a)
            : TabLoc.Messages.metricsTargetRowSubtitle(a);
    },
    metricsCustomStartDateOption: function () {
        return messageMap ? getMessage('metricsCustomStartDateOption') : TabLoc.Messages.metricsCustomStartDateOption();
    },
    metricsDateRangeAllTime: function () {
        return messageMap ? getMessage('metricsDateRangeAllTime') : TabLoc.Messages.metricsDateRangeAllTime();
    },
    metricsDateRangeSecondPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsDateRangeSecondPlural'), a)
            : TabLoc.Messages.metricsDateRangeSecondPlural(a);
    },
    metricsDateRangeSecondSingular: function () {
        return messageMap ? getMessage('metricsDateRangeSecondSingular') : TabLoc.Messages.metricsDateRangeSecondSingular();
    },
    metricsDateRangeMinutePlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsDateRangeMinutePlural'), a)
            : TabLoc.Messages.metricsDateRangeMinutePlural(a);
    },
    metricsDateRangeMinuteSingular: function () {
        return messageMap ? getMessage('metricsDateRangeMinuteSingular') : TabLoc.Messages.metricsDateRangeMinuteSingular();
    },
    metricsDateRangeHourPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsDateRangeHourPlural'), a)
            : TabLoc.Messages.metricsDateRangeHourPlural(a);
    },
    metricsDateRangeHourSingular: function () {
        return messageMap ? getMessage('metricsDateRangeHourSingular') : TabLoc.Messages.metricsDateRangeHourSingular();
    },
    metricsDateRangeDayPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsDateRangeDayPlural'), a)
            : TabLoc.Messages.metricsDateRangeDayPlural(a);
    },
    metricsDateRangeDaySingular: function () {
        return messageMap ? getMessage('metricsDateRangeDaySingular') : TabLoc.Messages.metricsDateRangeDaySingular();
    },
    metricsDateRangeMonthPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsDateRangeMonthPlural'), a)
            : TabLoc.Messages.metricsDateRangeMonthPlural(a);
    },
    metricsDateRangeMonthSingular: function () {
        return messageMap ? getMessage('metricsDateRangeMonthSingular') : TabLoc.Messages.metricsDateRangeMonthSingular();
    },
    metricsDateRangeWeekPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsDateRangeWeekPlural'), a)
            : TabLoc.Messages.metricsDateRangeWeekPlural(a);
    },
    metricsDateRangeWeekSingular: function () {
        return messageMap ? getMessage('metricsDateRangeWeekSingular') : TabLoc.Messages.metricsDateRangeWeekSingular();
    },
    metricsDateRangeQuarterPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsDateRangeQuarterPlural'), a)
            : TabLoc.Messages.metricsDateRangeQuarterPlural(a);
    },
    metricsDateRangeQuarterSingular: function () {
        return messageMap
            ? getMessage('metricsDateRangeQuarterSingular')
            : TabLoc.Messages.metricsDateRangeQuarterSingular();
    },
    metricsDateRangeYearPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsDateRangeYearPlural'), a)
            : TabLoc.Messages.metricsDateRangeYearPlural(a);
    },
    metricsDateRangeYearSingular: function () {
        return messageMap ? getMessage('metricsDateRangeYearSingular') : TabLoc.Messages.metricsDateRangeYearSingular();
    },
    metricsDateRangeByMarkPlural: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsDateRangeByMarkPlural'), a)
            : TabLoc.Messages.metricsDateRangeByMarkPlural(a);
    },
    metricsDateRangeByMarkSingular: function () {
        return messageMap ? getMessage('metricsDateRangeByMarkSingular') : TabLoc.Messages.metricsDateRangeByMarkSingular();
    },
    metricsGoodStatusDescription: function () {
        return messageMap ? getMessage('metricsGoodStatusDescription') : TabLoc.Messages.metricsGoodStatusDescription();
    },
    metricsBadStatusDescription: function () {
        return messageMap ? getMessage('metricsBadStatusDescription') : TabLoc.Messages.metricsBadStatusDescription();
    },
    metricsNeutralStatusDescription: function () {
        return messageMap
            ? getMessage('metricsNeutralStatusDescription')
            : TabLoc.Messages.metricsNeutralStatusDescription();
    },
    metricsDateRangeSlashFormat: function (a) {
        return messageMap
            ? exports.Messages.formatString(getMessage('metricsDateRangeSlashFormat'), a)
            : TabLoc.Messages.metricsDateRangeSlashFormat(a);
    },
};
//# sourceMappingURL=localization.js.map